import { DialogType, Dialog, DefaultButton, PrimaryButton, Label, DialogFooter } from "@fluentui/react";
import * as React from "react";
import SignPdf from "../Disclaimer/SignPdf";

interface Props {

    order: Order;

}

const DisclaimerHandler: React.FunctionComponent<Props> = props => {
    const [hidden, setHidden] = React.useState(true);
    const isSinged = props.order.orderProperties && props.order.orderProperties.signCalibrationChallenges;
    const dialogContentProps = {
        type: DialogType.normal,
        title: isSinged ? "Signed Disclaimer" : "Sign Disclaimer",
    };
    const toggleHideDialog = () => setHidden(!hidden);


    return (<>
        {isSinged ? (<PrimaryButton text="Signed Disclaimer" onClick={toggleHideDialog} />) : (<DefaultButton text="Sign Disclaimer" onClick={toggleHideDialog} />)}
        <Dialog
            hidden={hidden}
            dialogContentProps={dialogContentProps}
            onDismiss={toggleHideDialog}
            minWidth={500}
        >
            <SignPdf order={props.order} />
            <DialogFooter>
                <PrimaryButton
                    onClick={toggleHideDialog}
                    text="OK"
                />
                <DefaultButton
                    onClick={toggleHideDialog}
                    text="Anuller"
                />
            </DialogFooter>
        </Dialog>
    </>);
};

export default DisclaimerHandler;
